parameters.controller('ParametersListController', ['$scope', 'ParametersService', '$q', '$uibModal', 'toaster', 'LOGGED_USER', 'SU_TYPES',
    function ($scope, ParametersService, $q, $uibModal, toaster, LOGGED_USER, SU_TYPES) {
        $scope.tableParams = ParametersService.getNgTableParams();
        $scope.allowActionColumn = false;

        if ([SU_TYPES.su_app, SU_TYPES.su_it].indexOf(LOGGED_USER.suType) !== -1) {
            $scope.allowActionColumn = true;
        }
    }
]);